export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const API_KEY_VALUE = process.env.REACT_APP_API_KEY_VALUE;
export const DETECTING_TIME_INTERVAL = parseInt(
    process.env.REACT_APP_DETECTING_TIME_INTERVAL || "5000",
);
export const CLARITY_TOKEN = process.env.REACT_APP_CLARITY_TOKEN;
